var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.851 0.0952148H4.88685L3.02564 2.95048H1.42763H0V4.58206H1.42763V16.411C1.42763 17.4247 2.24942 18.2465 3.26316 18.2465H12.2368C13.2506 18.2465 14.0724 17.4247 14.0724 16.411V4.58206H15.5V2.95048H14.0724H12.6814L10.851 0.0952148ZM10.7433 2.95048H4.97325L5.77091 1.72679H9.95886L10.7433 2.95048ZM3.05921 16.615V4.58206H12.4408V16.615H3.05921ZM5.72993 13.5557L10.7494 8.48672L9.71026 7.43732L7.75161 9.41531L5.79602 7.44043L4.75689 8.48982L6.71247 10.4647L4.69079 12.5063L5.72993 13.5557ZM8.38519 12.1539L9.77007 13.5525L10.8092 12.5031L9.42433 11.1046L8.38519 12.1539Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.de19ff22440dd4f8360b4bf71e453d10.svg";
export { ForwardRef as ReactComponent };